export default __webpack_public_path__ + "static/media/fsiRealCase1-sc.5547f5a5.jpg";